import type { ReactNode } from "react";

export const ContactSubitemSection = ({
  title,
  count,
  children,
}: {
  title: string;
  count: number;
  children: ReactNode;
}) => {
  return (
    <section className="border-border border-b py-5 first:pt-0 last:border-b-0">
      <h3 className="mb-3 inline-flex flex-wrap items-baseline gap-x-1.5 text-base font-semibold">
        <span>{title}</span>
        {count > 0 ? (
          <span className="text-muted-foreground text-sm">({count})</span>
        ) : null}
      </h3>
      <div className="pl-2 [&_.contact-subitem-add]:pl-0.5">{children}</div>
    </section>
  );
};
